module.exports = __webpack_public_path__ + "static/media/apple-store.a81b4fa4.svg";